'use strict';

const setupI18Next = window => ($transitions, auth, moment, pmtEnvService) => {
	const parsedCookie = window.document.cookie.match(/language=(\w+)/);
	const lng = parsedCookie ? parsedCookie[1] : 'en';

	window.i18next.use(window.i18nextHttpBackend);

	const prom = window.i18next.init({
		// debug: true,
		lng,
		fallbackLng: false,
		load: 'all',
		defaultNS: 'listings',
		fallbackNS: ['general'],
		ns: ['general', 'listings'],
		backend: {
			allowMultiLoading: false,
			loadPath: pmtEnvService.i18NextLoadPath(lng),
			request: async (_options, url, _payload, callback) => {
				try {
					const response = await window.fetch(url);
					const data = await response.text();
					callback(null, { status: 200, data });
				} catch (err) {
					window.PinMeToLogger.log(
						new Error(`failed to fetch languages from cdn: ${err.message}. Url: ${url}`)
					);
					const ns = url.split('/').at(-2);
					const fallbackUrl = `/api/translations/${ns}/${lng}.json`;
					try {
						const response = await window.fetch(fallbackUrl);
						const data = await response.text();
						callback(null, { status: 200, data });
					} catch (err) {
						window.PinMeToLogger.log(
							new Error(`failed to fetch languages from proxy: ${err.message}. Url: ${fallbackUrl}`)
						);
						callback(err, { status: 500, data: null });
					}
				}
			}
		}
	});

	$transitions.onFinish({}, function () {
		return prom.then(function () {
			moment.changeLocale(auth.user.settings.language || 'en');
			return window.i18next.changeLanguage(auth.user.settings.language || 'en');
		});
	});

	return prom;
};

const i18NextFactory = window => {
	return { setupI18Next: setupI18Next(window) };
};

module.exports = {
	i18NextFactory
};
